var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrawerAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0563 22.008C16.1283 22.008 18.0883 21.952 18.0883 21.952C18.0883 21.952 20.1043 22.008 20.4963 20.16C20.4963 20.16 21.1123 16.968 18.8723 14.784C18.5923 14.56 18.1443 14.28 17.7523 14.28C17.4163 14.28 17.0803 14.392 16.8563 14.56C16.8563 14.56 15.1203 15.512 13.4403 15.288C12.4883 15.176 11.7603 14.84 11.1443 14.56C10.8643 14.392 10.5843 14.28 10.2483 14.28C9.91232 14.28 9.40832 14.56 9.12832 14.784C6.88832 16.912 7.50432 20.16 7.50432 20.16C7.84032 22.008 9.91232 21.952 9.91232 21.952C9.91232 21.952 11.8723 21.952 13.9443 22.008",
    stroke: "#EE2A7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9438 13.832C16.2325 13.832 18.0878 12.077 18.0878 9.91201C18.0878 7.74705 16.2325 5.992 13.9438 5.992C11.6551 5.992 9.7998 7.74705 9.7998 9.91201C9.7998 12.077 11.6551 13.832 13.9438 13.832Z",
    stroke: "#EE2A7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80165 24.8512C8.84298 26.1942 11.314 27 14 27C21.1983 27 27 21.1983 27 14C27 6.80165 21.1983 1 14 1C6.80165 1 1 6.80165 1 14C1 17.7066 2.55785 21.0372 5.02893 23.4008",
    stroke: "#3C3C3B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerAccount);
export default __webpack_public_path__ + "static/media/drawer-account.bc977a3c.svg";
export { ForwardRef as ReactComponent };